import { render, staticRenderFns } from "./RightValve.vue?vue&type=template&id=0582c12a&scoped=true"
import script from "./RightValve.vue?vue&type=script&lang=js"
export * from "./RightValve.vue?vue&type=script&lang=js"
import style0 from "./RightValve.vue?vue&type=style&index=0&id=0582c12a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582c12a",
  null
  
)

export default component.exports